import { render, staticRenderFns } from "./ContentCompiler.vue?vue&type=template&id=6877f588&scoped=true&lang=pug&"
import script from "./ContentCompiler.vue?vue&type=script&lang=js&"
export * from "./ContentCompiler.vue?vue&type=script&lang=js&"
import style0 from "./ContentCompiler.vue?vue&type=style&index=0&id=6877f588&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6877f588",
  null
  
)

export default component.exports